import { PipeObject, Token, Replacement } from '../types';

export const BlockQuote = () => {
  return ({ input, data, lex }: PipeObject) => {
    let obj: Token;
    let replacements: Replacement[] = [];
    while ((obj = lex.next())) {
      let blockStart, blockEnd;
      if (obj.token === 'block') {
        // we need to check if previous is an element_end or \n
        const pos = lex.position();
        lex.seek(obj.begin - 1);
        const prevObj = lex.next();
        if (prevObj?.token === 'element_end' || prevObj?.token === 'new_line') {
          // restore position before we moved backwards
          blockStart = obj;
          lex.seek(pos);
          while ((obj = lex.next())) {
            if (obj.token === 'new_line') {
              blockEnd = obj;
              break;
            }
          }
        } else {
          lex.seek(pos);
        }

        if (blockStart && blockEnd) {
          const value = input
            .substring(blockStart.end - 3, blockEnd.end)
            .trim();

          if (value) {
            replacements.push({
              searchValue: value,
              replaceValue: `<blockquote style="background:#f9f9f9;border-left: 10px solid #ccc;margin: 1.5em 10px;padding: 1em 10px 1em 10px;">${input
                .substring(blockStart?.end, blockEnd?.end)
                .trim()}</blockquote>`,
            });
          }
        }
      }
    }

    for (const rep of replacements) {
      input = input.replace(rep.searchValue, rep.replaceValue);
    }

    return { input, data, lex };
  };
};
